var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 col-lg-7 mb-3"},[_vm._t("default")],2),_c('div',{staticClass:"col-12 col-md-6 col-lg-5 mb-3"},[_c('TransactionSummary',{attrs:{"merchant":_vm.merchant,"company":_vm.company,"invoice":_vm.invoice,"transaction":_vm.transaction}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }